export default __webpack_public_path__ + "static/media/gsap_icon.69edf1a1.png";